import React, { createContext, useContext, useState } from 'react';
import SockJsClient from 'react-stomp';
import { UserContext } from '../Context/UserContext';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CommonUtils from '../../utils/CommonsUtils';
import Constants from '../../utils/Constants';
import axios from 'axios';
import EventBus from '../../eventbus/EventBus';
import _ from 'lodash';

const SOCKET_URL = process.env.REACT_APP_API_BASE_URL + '/ws';
const SOCKET_TOPIC = '/topic/message';
const SOCKET_HEADERS = {
    Authorization: sessionStorage.getItem(Constants.LOCAL_STORAGE.AUTHORIZATION) || ''
};

const defaultWebSocketContext = {};
export const WebSocketContext = createContext(defaultWebSocketContext);

export const WebSocketContextProvider = (props) => {
    let clientRef;
    const [requestWs, setRequestWs] = useState('');
    const [applicantsWs, setApplicantsWs] = useState(null);
    const [jobPostingWs, setJobPostingWs] = useState('');
    const [itemRoleWs, setItemRoleWs] = useState(null);
    const [reloadData, setReloadData] = useState(false);
    const [reloadEmployeeList, setReloadEmployeeList] = useState(false);
    const [isCloseBanner, setIsCloseBanner] = useState(false);
    const { isAuthenticated, setIsAuthenticated, setRole, userData, setUserData, setInvitedUser, setContextStatus, companyList, setCompanyList, selectedCompany, isSuperAdminRole } = useContext(UserContext);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    let onConnected = () => {
        console.log('WebSocket Connected!!');
    };

    let onDisConnected = () => {
        console.log('WebSocket Disconnected!!');
    };

    function roleUpdatedProcess(msgData) {
        axios.get(`member_invite/employeeRole?companyId=${msgData.companyId}&type=${msgData.type}${msgData.isDelete ? '' : `&typeId=${msgData.typeId}`}`).then((value) => {
            value.data && setInvitedUser(value.data);
        });
        setItemRoleWs(msgData);
        if (msgData.reloadData) setReloadData(true);
    }

    let onMessageReceived = (msgData) => {
        let name = msgData.name;
        const fromRequestDomain = msgData.fromRequestDomain;
        let currentLoggedInEmail = userData.email;
        switch (name) {
            case Constants.WEBSOCKET.SOCKET_FORCE_LOGOUT_CLIENT:
                if (currentLoggedInEmail === msgData.emailReceiver && window.location.origin === fromRequestDomain) {
                    // Force logout process
                    sessionStorage.removeItem(Constants.LOCAL_STORAGE.AUTHORIZATION);
                    sessionStorage.removeItem(Constants.SESSION_STORAGE.SELECTED_COMPANY_ID);
                    sessionStorage.removeItem(Constants.LOCAL_STORAGE.LANGUAGE);
                    setIsAuthenticated(false);
                    setRole([]);
                    setUserData({});
                    setInvitedUser({});
                    setContextStatus(Constants.CONTEXT_STATUS.IS_LOGOUT);
                    CommonUtils.displayConfirmAlert(t('login.forceLogoutMessage'), { label: t('button.ok'), onClick: () => navigate('/') });
                }
                break;
            case Constants.WEBSOCKET.SOCKET_ROLE_UPDATE:
                let roleName = msgData.roleName;
                if (currentLoggedInEmail === msgData.emailReceiver) {
                    setRole([roleName]);
                }
                break;
            case Constants.WEBSOCKET.SOCKET_JOB_APPLICANT_REQUEST:
                if (msgData.companyId === selectedCompany.companyId) {
                    setApplicantsWs(msgData);
                }
                break;
            case Constants.WEBSOCKET.SOCKET_JOB_POSTING_REQUEST:
                if (msgData && (msgData.jobPostingInfo.createdBy === userData.id || isSuperAdminRole())) setJobPostingWs(msgData);
                break;
            case Constants.WEBSOCKET.SOCKET_COMPANY_CONNECTED:
                if (currentLoggedInEmail === msgData.emailReceiver) {
                    companyList.push(msgData.data);
                    let clonedCompanyList = _.cloneDeep(companyList);
                    setCompanyList(clonedCompanyList);
                }
                if (msgData.data.companyId === selectedCompany.companyId) {
                    setReloadEmployeeList(true);
                }
                break;
            case Constants.WEBSOCKET.SOCKET_COMPANY_DISCONNECTED:
                if (currentLoggedInEmail === msgData.emailReceiver) {
                    let filtered = companyList.filter((company) => company.companyId !== msgData.companyId);
                    setCompanyList(filtered);
                }
                if (msgData.companyId === selectedCompany.companyId) {
                    setReloadEmployeeList(true);
                    EventBus.$dispatch(Constants.EVENT_BUS.HR_EMPLOYEE.DISCONNECT, {});
                    roleUpdatedProcess(msgData);
                }
                if (isMobile) {
                    window.location.href = '/companyDisconnected';
                }
                break;
            case Constants.WEBSOCKET.SOCKET_EMPLOYEE_ROLE_UPDATE:
                if (msgData.userIds.includes(userData.id) && msgData.companyId === selectedCompany.companyId) {
                    roleUpdatedProcess(msgData);
                }
                break;
            case Constants.WEBSOCKET.SOCKET_EMPLOYEE_LIST_UPDATE:
                if (msgData.companyId === selectedCompany.companyId) {
                    setReloadEmployeeList(true);
                }
                break;
            default:
                break;
        }
    };

    let sendWebSocketMessage = (msg) => {
        clientRef.sendMessage(SOCKET_TOPIC, msg);
    };

    let onSendMessage = (client) => {
        clientRef = client;
    };

    return (
        <WebSocketContext.Provider
            value={{
                requestWs,
                setRequestWs,
                sendWebSocketMessage,
                applicantsWs,
                jobPostingWs,
                setJobPostingWs,
                setApplicantsWs,
                setIsCloseBanner,
                setReloadData,
                setReloadEmployeeList,
                setItemRoleWs,
                itemRoleWs,
                reloadData,
                reloadEmployeeList,
                isCloseBanner
            }}
        >
            <div className="h-100">
                {isAuthenticated && <SockJsClient url={SOCKET_URL} headers={SOCKET_HEADERS} topics={[SOCKET_TOPIC]} onConnect={onConnected} onDisconnect={onDisConnected} onMessage={(msgData) => onMessageReceived(msgData)} ref={(client) => onSendMessage(client)} debug={false} />}
                {props.children}
            </div>
        </WebSocketContext.Provider>
    );
};

export default WebSocket;
